interface DateRange {
  start_date: string
  end_date: string
  getdiffDaysOption: (
    start_date: string,
    end_date: string,
  ) => string | boolean | undefined
}

const calculateStartDate = (diffDay: number) => {
  const today = new Date()
  const daysAgo = new Date()
  daysAgo.setDate(today.getDate() - diffDay)
  return daysAgo.toISOString().split('T')[0]
}

export const calculateDateRange = (option?: string): DateRange => {
  const today = new Date()
  const end_date = today.toISOString().split('T')[0]

  let start_date: string = ''

  switch (option) {
    case 'today':
      start_date = end_date
      break

    case '3 days': {
      start_date = calculateStartDate(3)
      break
    }

    case 'week': {
      start_date = calculateStartDate(7)
      break
    }

    case '2 weeks': {
      start_date = calculateStartDate(14)
      break
    }
  }

  const getdiffDaysOption = (start: string, end: string) => {
    if (end !== end_date) return false
    const diffDaysOptions = {
      [end_date]: 'today',
      [calculateStartDate(3)]: '3 days',
      [calculateStartDate(7)]: 'week',
      [calculateStartDate(14)]: '2 weeks',
    }

    return diffDaysOptions[start]
  }

  return { start_date, end_date, getdiffDaysOption }
}
